import type { AxiosResponse } from "axios";
import { AXIOS_POST_TIMEOUT_MS } from "src/config/axiosTimeout";
import { isBypassedOrganization } from "src/config/marketingActionBypass";
import type { Offer } from "src/types/offer";
import { OfferStatus } from "src/types/offerSlot";
import type { SponsoredAd } from "src/types/sponsored-ads";
import axios from "src/utils/axios";
import type { DuoFormOutput } from "src/views/marketing-actions/marketing-actions-create-view/types/MarketingActionFormOutput";
import type { MarketingActionErrorsModalEnum } from "src/views/sponsored-ads/routes";

export const createDuo = async (
    duoFormCreation: DuoFormOutput,
    organizationId?: number
): Promise<
    AxiosResponse<{
        offer: { offer: Offer; sponsoredAd: SponsoredAd; status: MarketingActionErrorsModalEnum };
    }>
> => {
    try {
        return await axios.post("/duo", duoFormCreation, { timeout: AXIOS_POST_TIMEOUT_MS });
    } catch (e: any) {
        if (e?.code === "ECONNABORTED" && isBypassedOrganization(organizationId)) {
            return { data: { offer: { status: OfferStatus.InCreation } } } as AxiosResponse<any>;
        }
        return;
    }
};
